module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-xs-12 col-lg-10 col-lg-offset-1"
  }, [_c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.allNudges.length),
      expression: "allNudges.length"
    }],
    staticClass: "table table-striped table-apps"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.allNudges), function(nudge, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(nudge.category))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(nudge.message.eng))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(nudge.dateFrom)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(nudge.dateTo)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(nudge.requiresResponse))]), _vm._v(" "), _c('td', [_c('router-link', {
      staticClass: "btn btn-primary",
      attrs: {
        "to": ("nudge?nudge=" + (nudge.id))
      }
    }, [_vm._v("View")])], 1)])
  }), 0)]), _vm._v(" "), (!_vm.processing && !_vm.allNudges.length) ? _c('h4', [_vm._v("No Nudge has been created yet")]) : _vm._e()])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n      NUDGES\n      "), _c('small', [_vm._v("View All Nudges")])]), _vm._v(" "), _c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Home")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("View All Nudges")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Category")]), _vm._v(" "), _c('th', [_vm._v("Message")]), _vm._v(" "), _c('th', [_vm._v("From")]), _vm._v(" "), _c('th', [_vm._v("To")]), _vm._v(" "), _c('th', [_vm._v("Requires Response")]), _vm._v(" "), _c('th', [_vm._v("View")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-f26a4ade","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/nudge/view.vue
// module id = 4yXZ
// module chunks = 1